// extracted by mini-css-extract-plugin
module.exports = {"switch":"PrivacyToggle_switch__14IxC","slider":"PrivacyToggle_slider__23XLj","text":"PrivacyToggle_text__mEjaW"};